import { useContext } from "react";
import { AdminPanelContext } from "../../../contexts/admin-panel/admin-panel";

export function useBulkUpload() {
    const { bulkUpload } = useContext(AdminPanelContext);
    return bulkUpload;
}
